import Controller from './helpers/Controller';

import 'slick-carousel';
import common from './controllers/common';
import slickFade from './components/slickFade';
import sectionCallToAction from './components/sectionCallToAction';
import nav from './components/nav';
import sliderTestimonies from './components/sliderTestimonies';
import ressourcesFilters from './components/ressourcesFilters';
import aboutTab from './components/aboutTab';
import letsGoForm from './components/letsGoForm';
import tarifsChoices from './components/tarifsChoices';
import burgerMenu from './components/burgerMenu';
import team from './components/team';
import imgCarre from './components/imgCarre';
import simpleParallax from './components/simpleParallax';
import accordeon from './components/accordeon';
import segmentViewMore from './components/segmentViewMore';
import stickySegment from './components/stickySegment';
import slickSegments from './components/sliderSegments';
import Collapse from './components/Collapse';


const modules = [
    common,
    slickFade,
    sectionCallToAction,
    nav,
    sliderTestimonies,
    ressourcesFilters,
    aboutTab,
    letsGoForm,
    tarifsChoices,
    burgerMenu,
    team,
    imgCarre,
    simpleParallax,
    accordeon,
    segmentViewMore,
    stickySegment,
    slickSegments,
    // MobileMenu,
    Collapse,
];

const controller = new Controller(modules);
controller.ready();
